import React, { useMemo } from "react";
import { getCumulativeResult } from "data/Querys"
import MirsTable from "components/general/table/Table";
import CaptionTable from "components/general/table/CaptionTable";
//General
import { useViewport } from 'components/general/useViewPort'
import { getRscObject } from "helpers/rsc";
import NotAvailable from 'components/common/NotAvailable'
import { ColumnsTeamsLeaders } from 'components/sports/gar/events/teams/Columns'
import { useQuery } from 'react-query'
import Loader from 'components/general/Loader'
import Label from "components/general/Label"
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";


const GarTeamsLeaders = ({ event }) => {
    const { mirs_competition, mirs_rsc, mirs_language } = useUrlFriendlyToParameters()
    const { breakPoint } = useViewport();
    const rscObj = getRscObject(mirs_rsc)
    const teamRsc = `${rscObj.discipline}${rscObj.sex}${event}${rscObj.phase}--------`
    // results data
    const { data, isError, isLoading } = useQuery(
        {
            queryKey: ['teamResults', mirs_competition, mirs_language, teamRsc],
            queryFn: getCumulativeResult,
            refetchInterval: 5000,
            staleTime: 5000,
            refetchIntervalInBackground: true,
            notifyOnChangeProps: ['data', 'error'],
        });

    if (isError) { return <NotAvailable /> }
    if (isLoading) { return <Loader /> }
    //if (!data?.cumulativeResults?.results) { return <NotAvailable /> }

    const resultStatus = data?.results?.status?.code;
    return (<GarResultTeamsLeaders data={data} event={event} />);
};

export default GarTeamsLeaders;

const GarResultTeamsLeaders = ({ data, event }) => {
    const { breakPoint } = useViewport();
    const resultStatus = data?.results?.status?.code;
    const { mirs_rsc } = useUrlFriendlyToParameters()
    const rscObj = getRscObject(mirs_rsc)
    const configEvent = useMemo(() => getConfiguration(breakPoint), [resultStatus, breakPoint]);
    const rsc = `${rscObj.discipline}${rscObj.sex}${event}}${rscObj.phase}--------`

    const topData = data?.cumulativeResults?.results?.slice(0, 3)


    return (
        topData && <MirsTable
            //Dato to show by row
            data={topData}
            //Columnas a visualizar 
            columns={configEvent.columns}
            //Key by row necesary in order to no paint innecesary
            keyRow='participant-code'
            //Component caption
            caption={configEvent.caption}
            //Columns to hidde 
            hiddenColumns={configEvent.hiddenColumns}
            //When show tble is sorted by 
            initialSortBy={configEvent.sortBy}
            id={`mirs-table-team-leaders-${rsc}`}
        />
    )
}

const getConfiguration = (breakPoint) => {
    let configuration = {
        caption: null,
        columns: [],
        hiddenColumns: [],
        sortBy: [],
    };

    configuration.caption = <CaptionTable
        leftCol={<h4 className="text-dark"><Label data={'HeaderCurrentLeaders'} /></h4>}
    />
    configuration.sortBy = [{ id: 'Rank', desc: false }]
    configuration.columns = ColumnsTeamsLeaders(breakPoint);
    return configuration;
};

